<div
  class="max-w-[1180px] mx-auto px-[16px] py-[16px] md:px-[40px] md:py-[24px] pb-16"
>
  @if (id === "new") {
    <h1
      class="mt-[16px] text-4xl leading-[1.05] font-semibold tracking-tight text-slate-900 mb-[32px]"
      i18n="Create user label"
    >
      {{ "createUser" | transloco }}
    </h1>
  }
  @if (id !== "new") {
    <h1
      class="mt-[16px] text-4xl leading-[1.05] font-semibold tracking-tight text-slate-900 mb-[32px]"
      i18n="Edit user label"
    >
      {{ "editUser" | transloco }}
    </h1>
  }
  <div>
    @if (id !== "new") {
      <app-user-basic-info-form
        [mode]="'edit'"
        [tenants]="tenantOptions"
        [userGroups]="userGroupsRepository.userGroups$ | async"
        [showPasswordField]="id === 'new'"
        (userSubmit)="onInfoSubmit($event)"
      >
      </app-user-basic-info-form>
    }
    @if (id === "new") {
      <app-user-basic-info-form
        [mode]="'new'"
        [tenants]="tenantOptions"
        [userGroups]="userGroupsRepository.userGroups$ | async"
        [showPasswordField]="id === 'new'"
        (userSubmit)="onInfoSubmit($event)"
      >
      </app-user-basic-info-form>
    }
    <div class="mt-4">
      <app-error-alert
        title="{{ 'couldNotSubmitTheUsersProfile' | transloco }}"
        i18n-title="User profile submit error alert"
        [errors]="submitErrors"
      ></app-error-alert>
    </div>
    @if (
      id !== "new" &&
      (authRepo.isInRole("Superadmin") || authRepo.isInRole("Administrator"))
    ) {
      <div class="mt-4">
        <app-change-password-form
          (passwordSubmit)="onPasswordSubmit($event)"
          [isReset]="true"
        ></app-change-password-form>
      </div>
    }
  </div>
</div>
